/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import {
	CosmosComponentContextProps,
	getHero,
	LegalBanner,
	LegalContentSections,
	useScrollClientHash,
} from "@cosmos/components";
import { PageLegalContentFragment } from "@cosmos/hygraph-schema";
import { useAuth } from "@cosmos/next-hooks";

import { TemplateProviders } from "../templates";

interface Props {
	pageData?: PageLegalContentFragment;
	componentContext: CosmosComponentContextProps;
	isGameMode?: boolean;
}

export const ClientPageProviders = ({ pageData, componentContext, isGameMode }: Props): React.JSX.Element => {
	useAuth(!componentContext.enableAuth);

	useScrollClientHash();

	return (
		<div id="legal-content-template">
			<TemplateProviders componentContext={componentContext}>
				<LegalBanner banner={pageData?.banner} bannerCountryCodes={pageData?.bannerCountryCodes} />
				{getHero(pageData?.hero)}
				<LegalContentSections sections={pageData?.sections || []} isGameMode={isGameMode} />
			</TemplateProviders>
		</div>
	);
};
